import React, { useMemo } from 'react';
import { useMood } from '../../contexts/MoodContext';
import { dayKey, fmtLongDay } from './moodDates';
import CheckInComposer from './CheckInComposer';
import CheckInList from './CheckInList';

/**
 * TodayView — a quick composer plus today's check-ins. Multiple per day are all
 * kept and shown newest-first; today is defined by the local calendar.
 */
export const TodayView: React.FC = () => {
  const { checkIns, preferences } = useMood();
  const todayKey = dayKey(new Date());

  const today = useMemo(
    () => checkIns.filter((c) => dayKey(new Date(c.createdAt)) === todayKey),
    [checkIns, todayKey]
  );

  return (
    <div className="mm-view">
      <section className="mm-panel mm-panel--moodfield">
        <h2 className="mm-panel__title">How are you feeling today?</h2>
        <p className="mm-panel__sub">Choose the feeling that matches your moment — tap an illustration.</p>
        <CheckInComposer />
      </section>

      <section className="mm-panel">
        <h2 className="mm-panel__title">{fmtLongDay(new Date())}</h2>
        {!preferences.saveHistory ? (
          <div className="mm-insights--empty">
            <p className="mm-empty-title">History is off</p>
            <p className="mm-empty-sub">Your check-ins aren’t being saved. Turn on “Save mood history &amp; journal” in the dashboard settings to build your journal.</p>
          </div>
        ) : today.length === 0 ? (
          <div className="mm-insights--empty">
            <p className="mm-empty-title">No check-ins yet today</p>
            <p className="mm-empty-sub">When you check in above, it’ll appear here with its time.</p>
          </div>
        ) : (
          <>
            <p className="mm-panel__sub">{today.length} check-in{today.length === 1 ? '' : 's'} today</p>
            <CheckInList records={today} />
          </>
        )}
      </section>
    </div>
  );
};

export default TodayView;
